import { render, staticRenderFns } from "./StudentEvaluation.vue?vue&type=template&id=613d50f0&lang=pug"
import script from "./StudentEvaluation.vue?vue&type=script&lang=js"
export * from "./StudentEvaluation.vue?vue&type=script&lang=js"
import style0 from "./StudentEvaluation.vue?vue&type=style&index=0&id=613d50f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports